module.exports = __webpack_public_path__ + "static/media/mind-tab1.4a32f598.png";